import { Suspense, useEffect, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { i18n } from "@lingui/core";
import { I18nProvider } from "@lingui/react";
import { dynamicActivate, getLanguage } from "./i18n";
import { ConfigProvider, } from 'antd';
// import { BuildDetectionProvider, } from 'build-release-detection';
import zhCN from 'antd/locale/zh_CN';
import enUS from 'antd/locale/en_US';
import 'dayjs/locale/zh-cn';
import dayjs from 'dayjs';

import reportWebVitals from './reportWebVitals';
import ErrorBoundary from './ErrorBoundary';
import useVersionCheck from './Common/useVersionCheck';
// import App from './App.tsx';
import './index.less';

// const loadHtml = <Spin spinning fullscreen />
const App = lazy(() => import('./App.tsx') as any);
/** 版本检查包装器 */
const VersionCheckWrapper = () => {
    useVersionCheck(60000); // 每60秒检查一次
    return <App />;
}
/** 国际化应用 */
const I18nApp = () => {
    useEffect(() => {
        // 动态加载语言包
        const language: string = getLanguage();
        console.log("index: load language =>", language);
        dynamicActivate(language);
        dayjs.locale(language === 'en' ? 'en' : 'zh-cn');
    }, []);


    return <I18nProvider i18n={i18n}>
        <Suspense>
            <ConfigProvider locale={getLanguage() === 'en' ? enUS : zhCN}>
                <ErrorBoundary>
                    <VersionCheckWrapper />
                </ErrorBoundary>
            </ConfigProvider>
        </Suspense>
    </I18nProvider>;
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <I18nApp />

    // <React.StrictMode>
    //     <ConfigProvider locale={zhCN}>
    //         <App />
    //     </ConfigProvider>
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// import { Suspense, useEffect, lazy } from 'react';
// import ReactDOM from 'react-dom/client';

// import { i18n } from "@lingui/core";
// import { I18nProvider } from "@lingui/react";

// import { dynamicActivate, getLanguage } from "./i18n";

// import { ConfigProvider } from 'antd';
// import zhCN from 'antd/locale/zh_CN';
// import enUS from 'antd/locale/en_US';

// import 'dayjs/locale/zh-cn';
// import dayjs from 'dayjs';

// import reportWebVitals from './reportWebVitals';
// import ErrorBoundary from './ErrorBoundary';
// import useVersionCheck from './Common/useVersionCheck';

// import './index.less';

// import { RouterProvider } from 'react-router-dom';


// /**
//  * 版本检查包装器
//  */
// const VersionCheckWrapper = ({ router }: { router: any }) => {
//     useVersionCheck(60000);

//     return <RouterProvider router={router} />;
// };

// /**
//  * 国际化应用
//  */
// const I18nApp = ({ router }: { router: any }) => {
//     return (
//         <I18nProvider i18n={i18n}>
//             <ConfigProvider
//                 locale={getLanguage() === 'en' ? enUS : zhCN}
//             >
//                 <ErrorBoundary>
//                     <VersionCheckWrapper router={router} />
//                 </ErrorBoundary>
//             </ConfigProvider>
//         </I18nProvider>
//     );
// };


// const startApp = async () => {
//     const language = getLanguage();

//     console.log("开始初始化 Lingui:", language);

//     // 先初始化 Lingui
//     await dynamicActivate(language);

//     console.log("Lingui 初始化完成:", i18n.locale);

//     // 设置 dayjs
//     dayjs.locale(language === 'en' ? 'en' : 'zh-cn');

//     // Lingui 初始化完成之后，再加载 Router
//     const { default: router } = await import("./Router");

//     console.log("Router 加载完成");

//     const root = ReactDOM.createRoot(
//         document.getElementById('root') as HTMLElement
//     );

//     root.render(
//         <I18nApp router={router} />
//     );

//     reportWebVitals();
// };

// startApp();